module.exports = __webpack_public_path__ + "static/media/paul_standby.ae4c342d.gif";